/**
 * Shadow & Elevation Design Tokens
 * Glassmorphism shadows, elevation levels, and glow effects
 * Based on DESIGN_TOKENS.md specification
 */

export const shadows = {
  // Glassmorphism shadows
  glass: {
    xs: '0 1px 3px rgba(0,0,0,0.08), 0 1px 2px rgba(0,0,0,0.04)',
    sm: '0 4px 6px rgba(0,0,0,0.07), 0 2px 4px rgba(0,0,0,0.06)',
    md: '0 10px 15px rgba(0,0,0,0.1), 0 4px 6px rgba(0,0,0,0.05)',
    lg: '0 20px 25px rgba(0,0,0,0.1), 0 10px 10px rgba(0,0,0,0.04)',
    xl: '0 25px 50px rgba(0,0,0,0.15)',
  },

  // Elevation levels
  elevation: {
    0: 'none',
    1: '0 1px 3px rgba(0,0,0,0.12)',
    2: '0 3px 6px rgba(0,0,0,0.15)',
    3: '0 10px 20px rgba(0,0,0,0.15)',
    4: '0 15px 35px rgba(0,0,0,0.2)',
    5: '0 20px 40px rgba(0,0,0,0.25)',
  },

  // Glow effects
  glow: {
    primary: '0 0 20px rgba(102, 126, 234, 0.4)',
    secondary: '0 0 20px rgba(240, 147, 251, 0.4)',
    success: '0 0 20px rgba(16, 185, 129, 0.4)',
    warning: '0 0 20px rgba(245, 158, 11, 0.4)',
    error: '0 0 20px rgba(239, 68, 68, 0.4)',
    info: '0 0 20px rgba(59, 130, 246, 0.4)',
  },

  // Inset shadows (for depth)
  inset: {
    sm: 'inset 0 1px 2px rgba(0,0,0,0.05)',
    md: 'inset 0 2px 4px rgba(0,0,0,0.1)',
    lg: 'inset 0 4px 8px rgba(0,0,0,0.15)',
  },
};

export type Shadows = typeof shadows;
export type ShadowValue = string;
